import sanitizeHtml from "sanitize-html";

interface SafeHTMLProps {
  html: string;
  className?: string;
}

export const Sanitize: React.FC<SafeHTMLProps> = ({ html, className }) => {
  const sanitizedHTML = sanitizeHtml(html, {
    allowedTags: ["a", "b", "br", "i", "em", "strong", "p", "span"],
    allowedAttributes: {
      a: ["href", "target", "rel", "class"],
      "*": ["class"],
    },
  });

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};
